import { motion } from "motion/react";
import { BugReportForm } from "@/components/bugs/bug-report-form.tsx";

const ease = [0.22, 1, 0.36, 1] as const;

const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease },
  },
};

export function BugsPage() {
  return (
    <section className="h-full w-full overflow-y-auto">
      <motion.div
        className="mx-auto w-full max-w-2xl space-y-8 px-5 py-12"
        variants={stagger}
        initial="hidden"
        animate="show"
      >
        <motion.div variants={fadeUp} className="space-y-2">
          <h1 className="font-bold font-space text-3xl tracking-tight">Report a Bug</h1>
          <p className="text-muted-foreground">
            Found something broken in Reify? Fill out the details below and attach your session log
            if you have one.
          </p>
        </motion.div>

        <motion.div variants={fadeUp}>
          <BugReportForm />
        </motion.div>
      </motion.div>
    </section>
  );
}
